import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import SmallcapsEditing from './smallcapsediting';
import SmallcapsUI from './smallcapsui';

export default class Smallcaps extends Plugin {
  static get requires() {
    return [ SmallcapsEditing, SmallcapsUI ];
  }

  static get pluginName() {
    return 'Smallcaps';
  }
}
